import { render, staticRenderFns } from "./ViewCategory.vue?vue&type=template&id=7f2ea908&scoped=true"
import script from "./ViewCategory.vue?vue&type=script&lang=js"
export * from "./ViewCategory.vue?vue&type=script&lang=js"
import style0 from "./ViewCategory.vue?vue&type=style&index=0&id=7f2ea908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2ea908",
  null
  
)

export default component.exports